import React, { useContext } from "react";
import DisDecline from "./decline";
import { UserContext } from "../../context/userContext";
import { useNavigate } from "react-router-dom";

export default function DisDeclineRoute(): React.JSX.Element {
  const navigate = useNavigate();
  const goToApp = () => {
    navigate("/");
  };

  const goToLogin = () => {
    navigate("/login");
  };

  const { email } = useContext(UserContext);
  const goNext = email ? goToApp : goToLogin;

  const renderComponent = () => {
    return <DisDecline next={goNext} loggedIn={!!email} />;
  };

  return renderComponent();
}
